import React from "react";
import { FileText } from "lucide-react";
import { safeHref } from "../lib/safeHref";

const isPdf = (url) => /\.pdf(\?|$)/i.test(url || "") || /content_type=pdf/.test(url || "");

export function EventFlyer({ event, className = "", compact = false, testId }) {
  const src = safeHref(event?.flyer_url);
  if (!src) return null;
  if (isPdf(event.flyer_url) || event.flyer_is_pdf) {
    return (
      <a href={src} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-2 rounded-lg border border-gold/40 bg-gold-light/60 px-3 py-2 text-sm font-semibold text-crimson hover:bg-gold-light ${className}`} data-testid={testId || `event-flyer-${event.id}`}>
        <FileText size={15} /> View event flyer (PDF)
      </a>
    );
  }
  return (
    <a href={src} target="_blank" rel="noreferrer" className={`block overflow-hidden rounded-xl border border-gold/30 ${className}`} data-testid={testId || `event-flyer-${event.id}`}>
      <img src={src} alt={`${event.title} flyer`} loading="lazy" className={`w-full object-cover ${compact ? "max-h-56" : "max-h-[520px]"} object-top`} />
    </a>
  );
}
